import { render, staticRenderFns } from "./CalendarNav.vue?vue&type=template&id=04a35f08&"
import script from "./CalendarNav.vue?vue&type=script&lang=js&"
export * from "./CalendarNav.vue?vue&type=script&lang=js&"
import style0 from "./CalendarNav.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports